import { Option } from '../../components/dropdown/Dropdown';
import { tenant } from '../../config/tenant';

export const DESKTOP_BREAKPOINT = 1199;
export const HEADER_HEIGHT_DESKTOP = 90;
export const HEADER_HEIGHT_MOBILE = 60;
export const FOOTER_HEIGHT_DESKTOP = 80;
export const FOOTER_HEIGHT_MOBILE = 120;

// Valores especificos da marca ativa (ver src/config/brands)
export const contacts = tenant.contacts;

export const socialMedia = {
	facebbok: '',
	x: '',
	instagram: '',
	linkedin: '',
};

export const baseApiUrl = tenant.api.baseApiUrl;

export const baseUrl = `${tenant.api.baseApiUrl.prod}/`;

export const externalBackofficeApiUrl = tenant.api.externalBackofficeApiUrl;

export const imagesBaseUrl = tenant.api.imagesBaseUrl;

export const graphColors = [
	'#f56954',
	'#00a65a',
	'#f39c12',
	'#00c0ef',
	'#3c8dbc',
	'#000080',
	'#FF00FF',
	'#800080',
	'#008080',
	'#00FFFF',
	'#00FF00',
	'#808000',
	'#808080',
	'#FA8072',
	'#CD5C5C',
	'#2874A6',
	'#F2D7D5',
	'#D7DBDD',
	'#848484',
	'#2F4F4F',
	'#6495ED',
	'#556B2F',
	'#7CFC00',
	'#9ACD32',
	'#FFD700',
	'#8B4513',
	'#F4A460',
	'#B22222',
	'#F08080',
	'#FF1493',
	'#8A2BE2',
	'#D8BFD8',
	'#FFFF00',
	'#99CC32',
	'#70DB93',
	'#32CD99',
	'#007FFF',
	'#6B238E',
	'#C0D9D9',
	'#3299CC',
	'#5F9F9F',
	'#42426F',
	'#00009C',
	'#23238E',
	'#3232CD',
];

export const tiposDeVeiculo: Option[] = [
	{ value: 1, label: 'Carro' },
	{ value: 2, label: 'Moto' },
	{ value: 3, label: 'Caminhão/Ônibus' },
];

export const tiposDeCombustivel: Option[] = [
	{ value: 'Álcool', label: 'Álcool' },
	{ value: 'Bi-Combustível', label: 'Bi-Combustível' },
	{ value: 'Gasolina', label: 'Gasolina' },
	{ value: 'Gasolina + Kit Gás', label: 'Gasolina + Kit Gás' },
	{ value: 'Diesel', label: 'Diesel' },
	{ value: 'Tetra Fuel', label: 'Tetra Fuel' },
	{ value: 'Híbrido Leve', label: 'Híbrido Leve' },
	{ value: 'Híbrido', label: 'Híbrido' },
	{ value: 'Híbrido Plug-In', label: 'Híbrido Plug-In' },
	{ value: 'Elétrico', label: 'Elétrico' },
];

export const tiposDeTransmissao: Option[] = [
	{ value: 'Manual', label: 'Manual' },
	{ value: 'Automático', label: 'Automático' },
	{ value: 'Semi-Automático', label: 'Semi-Automático' },
	{ value: 'Automatizado', label: 'Automatizado' },
];

export const offerPrice: number = 690;
export const offerPriceMotorcycle: number = 250;
export const offerPriceBus: number = 690;
export const allowedTimeToBuyStart: number = 0;
export const allowedTimeToBuyEnd: number = 24;
export const allowedTimeToCreateOfferStart: number = 8;
export const allowedTimeToCreateOfferEnd: number = 19;
export const minimumIncrementOffer: number = 200;

export const opcoesDeSimOuNao: Option[] = [
	{ value: '0', label: 'Não' },
	{ value: '1', label: 'Sim' },
	{ value: '2', label: 'Recusado' },
];

export const opcoesDeSimOuNaoBolean: Option[] = [
	{ value: 'false', label: 'Não' },
	{ value: 'true', label: 'Sim' },
];

export const opcoesDeSimOuNaoPendente: Option[] = [
	{ value: '0', label: 'Pendente' },
	{ value: '1', label: 'Sim' },
	{ value: '2', label: 'Não' },
	{ value: '3', label: 'Recusado' },


];

export const opcoesDeDocumento: Option[] = [
	{ value: '1', label: 'CPF' },
	{ value: '2', label: 'CNPJ' },
];

export const opcoesDePerfil = [
	{ value: 1, label: 'Administrador' },
	{ value: 2, label: 'Concessionária' },
	{ value: 3, label: 'Lojista' },
];

export const opcoesTagNaoComprar: Option[] = [
	{ value: '0', label: 'Sim' },
	{ value: '1', label: 'Não' },
];
